import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgXLogo = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M20.9 3h3.681l-8.041 9.318L26 25h-7.405l-5.805-7.69L6.156 25H2.47l8.6-9.969L2 3h7.593l5.241 7.028L20.9 3Zm-1.294 19.768h2.04L8.481 5.115h-2.19l13.314 17.653Z" />
  </svg>
);
export default SvgXLogo;
